import React, { useEffect, useState } from "react";
import MatchCard from "../Cards/MatchCard";
import axios from "axios";
import { Link } from "react-router-dom";

function BigMatchScore() {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMatches = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/external-matches`);
        const apiData = response.data;

        let matchesList = [];
        if (apiData?.data && Array.isArray(apiData.data)) {
          matchesList = apiData.data.map((item) => item?.external_data?.match).filter(Boolean);
        } else if (Array.isArray(apiData)) {
          matchesList = apiData;
        }

        setMatches(matchesList);
      } catch (error) {
        console.error("Error fetching matches:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMatches();
  }, []);

  const parseScore = (scoreText) => {
    if (!scoreText) return { score: "0", wicket: "0", overs: "0.0" };

    const innings = scoreText.split("&").map((s) => s.trim());

    const parseInning = (text) => {
      const match = text.match(/(\d+)\/(\d+)[d]?\s*\(?(\d+\.?\d*)?\)?/);
      if (match) {
        return { score: match[1] || "0", wicket: match[2] || "0", overs: match[3] || "" };
      }
      return { score: "0", wicket: "0", overs: "" };
    };

    const firstInning = parseInning(innings[0]);
    const secondInning = innings.length > 1 ? parseInning(innings[1]) : null;

    return {
      ...firstInning,
      score_2: secondInning?.score,
      wicket_2: secondInning?.wicket,
      overs_2: secondInning?.overs,
    };
  };

  if (loading) {
    return <div className="md:py-[110px] py-[80px] text-center">Loading matches...</div>;
  }

  return (
    <div className="md:py-[110px] py-[80px] pb-[64px] px-[24px]">
      <div className="container mx-auto">
        <div className="flex flex-col gap-[24px]">        
          <div className="flex justify-between items-center w-full text-[#B72828] italic font-medium gap-[12px] items-center sports-news-heading">
            <h2 className="md:text-[24px] text-[18px]">Recent Matches</h2>

            <Link
              to="/all-matches"
              className="text-[#9E120E] font-medium border border-[#9E120E] px-4 py-2 rounded-md hover:bg-[#9E120E] hover:text-white transition-colors duration-300"
            >
              View All
            </Link>
          </div>

          {/* ✅ Full width (2 columns desktop, 1 column mobile) */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
            {matches.length > 0 ? (
              matches.slice(0, 2).map((match, index) => {
                let statusClassName;
                let viewMatchSummaryClassName;

                let displayStatus = match.updated_way || "Recent";
                if (displayStatus === "LIVE") displayStatus = "Live";
                if (displayStatus === "FIXTURE") displayStatus = "Upcoming";
                if (displayStatus === "RESULT") displayStatus = "Recent";

                switch (displayStatus) {
                  case "Recent":
                    statusClassName = "bg-[#FFD4D2] text-[#9E120E]";
                    viewMatchSummaryClassName =
                      "flex justify-center text-white text-[14px] font-Rubik bg-red-gradient py-[12px]";
                    break;
                  case "Upcoming":
                    statusClassName = "bg-[#D4F1D2] text-[#006B2B]";
                    viewMatchSummaryClassName =
                      "flex justify-center text-white text-[14px] font-Rubik bg-green-gradient py-[12px]";
                    break;
                  case "Cancelled":
                    statusClassName = "bg-[#D4D4D4] text-[#231F20]";
                    viewMatchSummaryClassName =
                      "flex justify-center text-white text-[14px] font-Rubik bg-[#555555] py-[12px]";
                    break;
                  case "Live":
                    statusClassName = "bg-[#F1F1F1] text-[#9E120E]";
                    viewMatchSummaryClassName =
                      "flex justify-center text-white text-[14px] font-Rubik bg-[#B82222] py-[12px]";
                    break;
                  default:
                    statusClassName = "";
                    viewMatchSummaryClassName =
                      "flex justify-center text-white text-[14px] font-Rubik py-[12px]";
                    break;
                }

                const team1Stats = parseScore(match.team1_score_text);
                const team2Stats = parseScore(match.team2_score_text);

                return (
                  <div key={index} className="w-full">
                    <MatchCard
                      title={match.series_name || match.match_name || "Match"}
                      match_day={
                        match.match_date
                          ? new Date(match.match_date).toLocaleDateString("en-US", { weekday: "long" })
                          : ""
                      }
                      match_date={match.match_date ? new Date(match.match_date).toLocaleDateString("en-US") : ""}
                      match_time={match.time || ""}
                      status={displayStatus}
                      match_type={match.type_name || "Match"}
                      teams={[
                        {
                          school_name: match.team1_name || match.team1_school_name || "Team 1",
                          score: team1Stats.score,
                          wicket: team1Stats.wicket,
                          overs: team1Stats.overs,
                          score_2: team1Stats.score_2,
                          wicket_2: team1Stats.wicket_2,
                          overs_2: team1Stats.overs_2,
                          full_score: match.team1_score_text,
                          school_logo: match.team1_school_image,
                        },
                        {
                          school_name: match.team2_name || match.team2_school_name || "Team 2",
                          score: team2Stats.score,
                          wicket: team2Stats.wicket,
                          overs: team2Stats.overs,
                          score_2: team2Stats.score_2,
                          wicket_2: team2Stats.wicket_2,
                          overs_2: team2Stats.overs_2,
                          full_score: match.team2_score_text,
                          school_logo: match.team2_school_image,
                        },
                      ]}
                      result={match.match_result_text || match.match_status_text || ""}
                      playground={match.ground_name || ""}
                      statusClassName={statusClassName}
                      viewMatchSummaryClassName={viewMatchSummaryClassName}
                      handleClick={`/external-match-view/${match.match_id}`}
                    />
                  </div>
                );
              })
            ) : (
              <div className="text-center text-gray-500 w-full col-span-1 md:col-span-2 py-10">No matches found</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BigMatchScore;
